import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Button } from './ui/button';

export default function PageIntroDialog({ open, onClose, title, subtitle, icon: Icon, color = '#2563eb', bullets = [], example }) {
  const safeBullets = Array.isArray(bullets) ? bullets.filter(Boolean) : [];
  const safeExample = example != null ? String(example).trim() : '';

  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
      <DialogTitle sx={{ pb: 1.5 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: alpha(color, 0.15),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            {Icon ? <Icon size={20} color={color} /> : null}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: 900, lineHeight: 1.15 }}>
              {String(title || '')}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                {String(subtitle)}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {safeBullets.length ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {safeBullets.map((text, idx) => (
              <Typography key={idx} variant="body2" sx={{ display: 'flex', gap: 1 }}>
                <Box component="span" sx={{ fontWeight: 900 }}>
                  •
                </Box>
                <Box component="span" sx={{ flex: 1 }}>
                  {String(text)}
                </Box>
              </Typography>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {String(subtitle || '')}
          </Typography>
        )}
        {safeExample ? (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 1 }}>
              Esempio
            </Typography>
            <Paper
              variant="outlined"
              sx={(theme) => ({
                borderRadius: '16px',
                px: 2,
                py: 1.5,
                bgcolor: theme.palette.mode === 'dark' ? alpha('#0b1220', 0.35) : '#f8fafc'
              })}
            >
              <Typography variant="body2">{safeExample}</Typography>
            </Paper>
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Continua</Button>
      </DialogActions>
    </Dialog>
  );
}
